import { KycStatus } from "../types/KycStatus";
import { UserInfo } from "../types/UserInfo";

/**
 * Non-identifying placeholder investor for the standalone dev-harness views.
 * Never put real investor data here: these views are part of the production bundle.
 */
const MOCK_INVESTOR_ID = "000000000000000000000001";
const MOCK_EMAIL = "investor@example.com";
const MOCK_PHONE = {
  code: "1",
  number: "555 555 0100",
  fullNumber: "+15555550100",
  isVerified: true,
} as const;

export const MOCK_USER_INFO: UserInfo = {
  role: "admin",
  investorId: MOCK_INVESTOR_ID,
  email: MOCK_EMAIL,
  contactEmail: MOCK_EMAIL,
  fullName: "Jane Doe",
  verificationStatus: KycStatus.VERIFIED,
  entityName: "",
  suitabilityStatus: "approved",
  accountStatus: "approved",
  investorType: "individual",
  state: "AZ",
  countryCode: "US",
  brokerDealerId: 24,
  pendingDeletion: false,
  accreditationStatus: "processing",
  language: "EN",
  contactDetails: {
    phone: MOCK_PHONE,
  },
  investorUserId: "000000000000000000000002",
  investorUserEmail: MOCK_EMAIL,
  userInvestors: [
    {
      investorId: MOCK_INVESTOR_ID,
      createDate: "2024-01-01T00:00:00.000Z",
      verificationErrors: [],
      allVerificationErrors: [],
      isHidden: false,
      details: {
        investorType: "individual",
        address: {
          countryCode: "US",
          state: "AZ",
          city: "Phoenix",
          entrance: "",
          street: "123 Main St",
          zip: "85001",
          houseNumber: "",
        },
        comments: [],
        verificationComments: [],
        tax: [
          {
            taxId: "000-00-0000",
            taxCountryCode: "US",
            _id: "000000000000000000000003",
          },
        ],
        displayName: "Jane Doe",
        phone: MOCK_PHONE,
        birthCity: "Phoenix",
        birthCountry: "US",
        birthState: "AZ",
        gender: "female",
        birthday: "1990-01-01T00:00:00.000Z",
        comment: "",
        firstName: "Jane",
        lastName: "Doe",
      },
      email: MOCK_EMAIL,
      contactEmail: MOCK_EMAIL,
      mixPanelId: "",
      analyticsEnabled: false,
      verificationLevel: "standard",
      verificationStatus: "verified",
      verificationSubStatus: "enhance-requested",
      accreditationStatus: "processing",
      accreditationStatusComment: "",
      accreditationStatusComments: [],
      accreditationStatusChangeDate: "2024-01-01T00:00:00.000Z",
      accreditationId: "00000000-0000-0000-0000-000000000000",
      pendingDeletion: false,
      deletionDeclineDate: "",
      lastIssuerContext: {
        issuerId: "",
        date: "2024-01-01T00:00:00.000Z",
      },
      brokerDealerId: 24,
      requestedUpdates: [],
      labels: [],
      accountStatus: "approved",
      accountStatusSignature: "",
      accountEuStatus: "approved",
      accountEuStatusSignature: "",
      annualIncome: [],
      approvedIssuerIds: ["00000000-0000-0000-0000-000000000000"],
      lastLoggedIn: "2024-01-01T00:00:00.000Z",
      role: "admin",
    },
  ],
  isEnhancedVerificationRequested: true,
  isOwner: true,
  hasBdAccess: true,
};
